/* eslint-disable */
import StoreManager from '../manager/StoreManager';
import { mapActions, mapGetters } from 'vuex';

const debug = process.env.NODE_ENV !== 'production';
const storeManager = new StoreManager();

function install(Vue, options) {
  if (!storeManager.store && options.Vuex) {
    options.config = {
      state: {},
      strict: debug,
    };

    storeManager.store = options;
  }

  if (storeManager.store) {
    Vue.mixin({ store: storeManager.store });
  }
}

function normalizeActions(store) {
  // for spread usage
  // ...mapActions([names,...,...])
  store.mapActions = (function (localKey, payload) {
    let mapped = mapActions(localKey, payload);
    let mappedFns = {};
    for (var key in mapped) {
      mappedFns[key] = mapped[key].bind(this);
    }
    return mappedFns;
  });
}

function normalizeGetters(store) {


  // // for spread usage.
  // // ...mapGetters([names,...,...])
  store.mapGetters = (function (localKey, payload) {
    let mapped = mapGetters(localKey, payload);
    let mappedFns = {};
    for (var key in mapped) {
      mappedFns[key] = mapped[key].call(this);
    }
    return mappedFns;
  });
}

function load(appModule, externalStore) {
  const module = Object.assign({}, appModule);

  if (module.stores) {
    // register global custom stores with vue store.
    Object.keys(module.stores).forEach(key => {
      (externalStore || storeManager.store).registerModule(key, module.stores[key]);

      normalizeActions(storeManager.store);
      normalizeGetters(storeManager.store);
    })
  }
}


export default {
  get store() {
    return storeManager.store;
  },
  install,
  load,
};



// WEBPACK FOOTER //
// ./src/plugin/StorePlugin.js